import { Component, OnInit } from '@angular/core';
// import { BreadcrumbService } from '../breadcrumb.service';
import { Observable } from 'rxjs';
import { BreadcrumbService } from '../../../services/breadcrumb.service';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.css',
  imports: [AsyncPipe, RouterLink],
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs$: Observable<{ label: string; url: string }[]>;

  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
  }

  ngOnInit(): void {}
}
